
<template>
  <v-container fill-height
               fluid
               grid-list-xl>
    <v-layout justify-center
              wrap>

      <v-flex xs12 md12 lg10>
        <material-card :color="getTitleColorStore"
                       :title="$t('menu_seminar_task_upload')"
                       text="">
          <ProgressBar :loading="loading" color="deep-purple accent-4" />


          <v-card>
            <v-container id="dropdown-example" grid-list-xl>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-card-title class="title pa-0">{{ $t('documents.upload.less_then_limit_title', { 'n': 100 }) }}</v-card-title>
                </v-flex>

                <v-flex xs12>
                  <SeminarUploadSelect :UslugeZaSeminarski="podaciZaSelect" :odabir="setOdabraniProgram" :setLoader="selectLoading"></SeminarUploadSelect>

                </v-flex>

                <!--Upload kontrola-->
                <v-flex xs12 md4 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <img :src="imageUrl" height="150" v-if="imageUrl" />
                  <v-text-field :label="$t('documents.upload.file_upload_label')" @click='pickFile' v-model='fileName' prepend-icon='attach_file'></v-text-field>
                  <input type="file"
                         style="display: none"
                         ref="image"
                         @change="onFilePicked">
                  <!--accept="image/*"-->
                </v-flex>
                <v-flex xs12 md2 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <v-btn color="blue darken1" @click="uploadAssignment">
                    <span class="white--text">{{$t('documents.upload.upload')}}</span>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>

          <v-divider></v-divider>
          <SeminarHistoryStatus :statusi="statusi" :setLoading="setStatusLoading"></SeminarHistoryStatus>

          <v-divider></v-divider>
          <SeminarUploadLarge></SeminarUploadLarge>


        </material-card>
      </v-flex>







    </v-layout>
  </v-container>

</template>

<script>
  import moment from 'moment';
  import { mapState, mapMutations, mapGetters } from 'vuex';
  import SeminarHistoryStatus from './components/SeminarHistoryStatus.vue';
  import SeminarUploadSelect from './components/SeminarUploadSelect.vue';
  import SeminarUploadLarge from './components/SeminarUploadLarge.vue';

  export default {
    name: 'SeminarUpload',

    props: {

    },

    computed: {
      ...mapGetters('app', { getTitleColorStore: 'getTitleColor' }),
      loading() {
        return this.loadingPrograme || this.loadingStatuse || this.uploading;
      }

    },

    data() {
      return {
        loadingPrograme: false,
        loadingStatuse: false,
        uploading: false,
        title: "Image Upload",
        dialog: false,
        fileName: '',
        imageUrl: '',
        selectedFile: '',
        odabraniProgram: null,
        podaciZaSelect: [],
        statusi: [],

      }
    },

    mounted() {

    },


    methods: {

      selectLoading(isLoading) {
        this.loadingPrograme = isLoading;
      },

      setStatusLoading(isLoading) {
        this.loadingStatuse = isLoading;
      },

      setOdabraniProgram(program) {
        this.odabraniProgram = program;
        this.getStatuse();
      },

      async getStatuse() {
        var self = this;

        this.setStatusLoading(true);
        var data = { GetSamoStatuse: true };
        var result = await this.$fetchDataPromise('/api/Documents/GetPodatkeZaUploadSeminarskog', data).catch(x => { this.setStatusLoading(false); this.$displayError(x); });
        this.statusi = result.map(x => {
          var obj = x;
          var istekao = x.UpisIstekao ? ` (${self.$t('documents.upload.enrollment_expired')})` : '';
          obj.Ime = x.Ime + istekao;
          return obj;
        });
        this.setStatusLoading(false);
      },


      pickFile() {
        this.$refs.image.click()
      },
      onFilePicked(e) {
        const files = e.target.files
        if (files[0] !== undefined) {
          this.fileName = files[0].name
          if (this.fileName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            //this.imageUrl = fr.result // U slučaju uploada slike, ovo daje preview
            this.selectedFile = files[0] // this is an image file that can be sent to server...
          })
        } else {
          this.fileName = ''
          this.selectedFile = ''
          this.imageUrl = ''
        }
      },

      uploadAssignment() {
        var self = this;
        var url = '/api/Documents/UploadSeminarskiRad'
        var formDataAxios = new FormData();

        if (this.selectedFile && this.odabraniProgram != null && !this.odabraniProgram.UpisIstekao) {

          formDataAxios.set('upisPoId', this.odabraniProgram.UpisPO_ID);
          formDataAxios.set('naziv', this.odabraniProgram.Naziv);
          formDataAxios.set('Ime', this.odabraniProgram.Ime);
          formDataAxios.append('file', this.selectedFile);
          this.uploading = true;
          
          this.$axiosUpload(url, formDataAxios)
            .then(function () {
              self.getStatuse(); // refresh historya
              self.$displaySuccess(self.$t('documents.upload.upload_success'))
              self.selectedFile = null;
              self.fileName = null;
              self.uploading = false;
            })
            .catch(error => {
              if (error.response) {
                this.$displayError(error.response.data.Message);
                self.uploading = false;
              } else if (error.message) {
                this.$displayError(error.message);
                self.uploading = false;
              }
            });
        } else if (this.odabraniProgram != null && this.odabraniProgram.UpisIstekao) {
          this.$displayError(this.$t('documents.upload.enrollment_expired'));
          self.uploading = false;
        }
        else {
          this.$displayError(this.$t('documents.upload.file_not_selected'));
          self.uploading = false;
        }


      }

    },


    components: {
      SeminarHistoryStatus, SeminarUploadSelect, SeminarUploadLarge
    }

  }
</script>



// WEBPACK FOOTER //
// VueSrc/SeminarTask/SeminarTaskUpload.vue